import serviceUrls from 'src/constants/serviceUrls';
import axiosRequest from 'src/helpers/axiosRequest';

export function api_getCalculations(params) {
  return axiosRequest('post', serviceUrls.WHATIF_GET_CALCULATIONS, params, { timeout: 180000 });
}

export function api_downloadExcel(params) {
  return axiosRequest('post', serviceUrls.WHATIF_DOWNLOAD_EXCEL, params, { responseType: 'arraybuffer' });
}

export function api_getCountriesDictionary() {
  return axiosRequest('get', serviceUrls.WHATIF_GET_COUNTRIES_DICTIONARY);
}
